module.exports = __webpack_public_path__ + "static/media/TamilMN.5bf98563.ttf";